import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { type ColorType, theme } from "../theme/lexusTheme";
import { IconWrapper } from "./IconWrapper";

type ListType = {
    type?: "inline" | "unstyled";
};

export const List = styled.ul.attrs<ListType>((props) => ({
    className: props.type ? `list-${props.type}` : "",
}))``;

export const ListInlineItem = styled.li.attrs(() => ({
    className: "list-inline-item",
}))``;

/**
 * List Variant: Specification list
 */
export const SpecificationList = styled.ul.attrs(() => ({
    className: "specification-list",
}))``;

export const SpecificationListItem = styled.li.attrs(() => ({
    className: "specification-item",
}))``;

/**
 * List Variant: Special links
 */
export const SpecialLinks = styled.ul.attrs(() => ({
    className: "cmp-special-links",
}))``;

export const SpecialLinksItem = styled.li.attrs(() => ({
    className: "special-links-item",
}))``;

/**
 * List Variant: Subfooter
 */
export const SubFooterList = styled.ul.attrs(() => ({
    className: "subfooter-list",
}))``;

export const SubFooterListItem = styled.li.attrs(() => ({
    className: "subfooter-item",
}))``;

export const DefList = styled.dl`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    dt,
    dd {
        font-size: 1.3rem;
        font-weight: normal;
        line-height: 2.8rem;
    }

    dt {
        width: 33.33333%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    dd {
        width: 66.66666%;
        color: ${theme.colors.platinumDark};
    }
`;

/**
 * List Variant: Bullet list
 */

export const BulletList = styled.ul<SpaceProps>`
    display: block;
    margin: ${theme.space[2]}px 0;
    padding: 0;
    line-height: 3rem;
    ${space};

    + ul {
        margin-top: -${theme.space[1]}px;
    }
`;

export const BulletListItem = styled.li<{ color?: ColorType }>`
    &,
    span:not(:empty) {
        font-size: 1.8rem;
        line-height: 1.5;
        color: ${({ color }) => (color ? theme.colors[color] : theme.colors.platinumDark)};
    }

    display: list-item;
    position: relative;
    margin-bottom: ${theme.space[1]}px;
    padding-left: 20px;
    list-style-type: none;
    &::before {
        position: absolute;
        top: 4px;
        left: 0;
        font-size: 3rem;
        line-height: 2rem;
        color: ${theme.colors.midnight};
        content: "·";
        vertical-align: sub;
    }
    .icon::before {
        font-size: 1.3rem !important; /* should be smaller font in list because of horizontal centering with bullet */
    }

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: 20px;
        &::before {
            left: auto;
            right: 0;
        }
    }
`;

/**
 * List variant: Icon list
 */
export const IconList = styled.ul`
    display: block;
    margin: ${theme.space[2]}px 0;
    padding: 0;
    line-height: 3rem;

    + ul {
        margin-top: -${theme.space[1]}px;
    }
`;

export const IconListItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: ${theme.space[3]}px;

    ${IconWrapper} {
        min-width: 30px;
        margin-inline-end: ${theme.space[3]}px;
        color: ${theme.colors.midnight};
    }
`;

export const IconListItemText = styled.div`
    font-family: ${theme.fonts.book};
    font-size: 1.8rem;
    line-height: 2.6rem;
    color: ${theme.colors.brushedSteel};

    strong {
        display: block;
        margin-bottom: 0;
        font-family: ${theme.fonts.book};
        line-height: 3rem;
        text-transform: none;
        color: ${theme.colors.midnight};
    }
`;
